var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 订单提交成功 "),_c('div'),_vm._v(" 订单编号为xxxx1111 "),_c('div'),_vm._v(" 您可在《所有订单》中查看该订单的详情 ")])}]

export { render, staticRenderFns }